module.exports = __webpack_public_path__ + "material-icon.41f99548addef5d02243.woff2";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/material-icon.woff2
// module id = ../../../../../src/assets/fonts/material-icon.woff2
// module chunks = styles